import React from 'react';
import { CircleDotIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { identifyItems } from '../../data/content';
export function Identify() {
  return <Section tone="cream" data-id="element-210" data-mp="29x31qqni7xlf">
      <Eyebrow data-id="element-211" data-mp="29uqp8t0imffr">¿Es para ti?</Eyebrow>
      <Heading data-id="element-212" data-mp="2evwh6omcpyo8">¿Te identificas con alguna de estas situaciones?</Heading>
      <p className="mt-3 text-center text-[14.5px] font-semibold text-navy/60" data-id="element-213" data-mp="1h7w7w4yzvw6i">
        Si respondes sí a dos o más, este sistema fue diseñado para ti.
      </p>

      <ul className="mt-7 space-y-2.5" data-id="element-214" data-mp="1m78r8fqnql4c">
        {identifyItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-navy/10 bg-white px-4 py-3.5" data-id="element-215" data-mp="1r5a9wzk68ifa">
            <CircleDotIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-216" data-mp="yheerza92ykm" />
            <span className="text-[14px] leading-snug text-navy/80 sm:text-[15px]" data-id="element-217" data-mp="13ghmxslj1kwt">{item}</span>
          </li>)}
      </ul>

      <div className="mt-9 rounded-3xl bg-navy p-5 text-center sm:p-7" data-id="element-218" data-mp="nl7cznmrxz6q">
        <p className="font-serif text-[21px] font-extrabold leading-snug text-white sm:text-3xl" data-id="element-219" data-mp="ilusvanaf67u">
          Aquí es donde todo cambia.
        </p>
        <p className="mx-auto mt-3 max-w-lg text-[14.5px] leading-relaxed text-white/75 sm:text-base" data-id="element-220" data-mp="dttffledv9g8">
          En lugar de memorizar cientos de recomendaciones, tendrás un sistema que organiza las
          decisiones clínicas en el orden en que realmente ocurren durante la consulta.
        </p>
        <div className="mx-auto mt-5 grid max-w-md gap-2" data-id="element-221" data-mp="3vzzitz404q6l">
          {['Cada algoritmo responde una pregunta concreta.', 'Cada tomo resuelve una etapa del manejo del paciente.', 'Cada herramienta te ayuda a decidir con rapidez y seguridad.'].map(item => <p key={item} className="rounded-xl bg-white/[0.07] px-3.5 py-2.5 text-[13.5px] font-semibold text-white/90" data-id="element-222" data-mp="1p9rm5im39jea">
              {item}
            </p>)}
        </div>
      </div>

      <SectionCTA promise="Reemplaza la memoria por un método que puedes aplicar hoy mismo." label="Quiero aplicar el método ya" data-id="element-223" data-mp="3ji56hyouztpe" />
    </Section>;
}